export default __webpack_public_path__ + "static/media/one.c7949612.glb";